module.exports = __webpack_public_path__ + "static/img/ptherleft1.2b9353d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/ptherleft1.png
// module id = POu6
// module chunks = 1